import {IResource} from '../iresource';
import {ResourceBase} from '../resource-base';

export class CodeResource extends ResourceBase implements IResource {
   constructor(json: any) {
      super(json);
   }
}



// WEBPACK FOOTER //
// ./src/app/models/game/resources/code/code-resource.ts